import React from "react";
import { Modal } from "react-bootstrap";
import { useMutation } from "@apollo/react-hooks";
import { monoClient } from "../../apolloClient";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { CLUB_MEMBERSHIP_FORM } from "../../mutation/clubMembershipFormApi";

const MembershipFormPopup = (props) => {
  const [clubMembershipForm] = useMutation(CLUB_MEMBERSHIP_FORM, {
    client: monoClient,
  });
  return (
    <Modal
      {...props}
      className="membership-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="left-side-container-membership">
          <div className="form-headind-cl">Club Sign Up</div>
          <p style={{ color: "#8E8E93" }}>
            Please fill out the form below with your club details.
          </p>
          <div className="membership-form">
            <div className="membership-form-box">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  club_name: "",
                  members: "",
                  contact_name: "",
                  phone: "",
                  email: "",
                  address: "",
                  city: "",
                  state: "",
                  postcode: "",
                  abn: "",
                }}
                validationSchema={Yup.object({
                  club_name: Yup.string().required(
                    "Please anter the club name"
                  ),
                  members: Yup.number().required(
                    "Please the number of members"
                  ),
                  contact_name: Yup.string().required(
                    "Please enter the contact name"
                  ),
                  phone: Yup.number()
                    .typeError("Please add only numbers")
                    .required("Please enter the phone number"),
                  email: Yup.string()
                    .required("Please enter the email")
                    .email("Invalid Email Address"),
                  address: Yup.string().required("Please enter the city name"),
                  city: Yup.string().required("Please enter the city name"),
                  state: Yup.string().required("Please enter the state name"),
                  postcode: Yup.number().required("Please enter the postcode"),
                  abn: Yup.string()?.test(
                    "len",
                    "Must have 11 digits",
                    (val) => val && val.length === 11
                  ),
                })}
                onSubmit={(values) => {
                  clubMembershipForm({
                    variables: {
                      date: new Date(),
                      clubName: values.club_name,
                      contactName: values.contact_name,
                      numberOfMember: values.members,
                      phoneNumber: values.phone,
                      email: values.email,
                      address: values.address,
                      city: values.city,
                      state: values.state,
                      postCode: values.postcode,
                      abn: values.abn,
                    },
                  })
                    .then((res) => {
                      props.setIsMemberShipModalOpen(false);
                      props.setIsSuccessMemberShipModalOpen(true);
                      localStorage.removeItem("user_profile_role");
                      localStorage.removeItem("term_and_conditions");
                      localStorage.setItem("isnewuser", true);
                    })
                    .catch((e) => {});
                }}
              >
                {() => (
                  <Form>
                    <div>
                      <div className="d-flex flex-row gap-3">
                        <div className="form-group full-width">
                          <label>Club Name</label>
                          <Field
                            type="name"
                            name="club_name"
                            className="form-control"
                            placeholder="Club"
                            style={{ backgroundColor: "white" }}
                          />
                          <ErrorMessage
                            name="club_name"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="form-group full-width">
                          <label>Number of Members</label>
                          <Field
                            type="number"
                            name="members"
                            className="form-control"
                            placeholder="Members"
                            style={{ backgroundColor: "white" }}
                          />
                          <ErrorMessage
                            name="members"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </div>
                      <div className="form-group full-width">
                        <label>Contact Name</label>
                        <Field
                          type="text"
                          name="contact_name"
                          className="form-control"
                          placeholder="Name"
                          style={{ backgroundColor: "white" }}
                        />
                        <ErrorMessage
                          name="contact_name"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="form-group full-width">
                        <label>Phone number</label>
                        <div className="input-group mb-3">
                          <span
                            className="input-group-text"
                            id="phone"
                            style={{
                              backgroundColor: "white",
                              color: "#161F3D",
                              borderRadius: "0px",
                            }}
                          >
                            AU
                          </span>
                          <Field
                            type="number"
                            name="phone"
                            className="form-control"
                            placeholder="0412 345 678"
                            style={{ backgroundColor: "white" }}
                          />
                        </div>
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="form-group full-width">
                        <label>Email</label>
                        <Field
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="you@company.com"
                          style={{ backgroundColor: "white" }}
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="form-group full-width">
                        <label>Address</label>
                        <Field
                          type="text"
                          name="address"
                          className="form-control"
                          placeholder="Address"
                          style={{ backgroundColor: "white" }}
                        />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="d-flex flex-row gap-3">
                        <div className="form-group full-width">
                          <label>City</label>
                          <Field
                            type="text"
                            name="city"
                            className="form-control"
                            placeholder="City"
                            style={{ backgroundColor: "white" }}
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="form-group full-width">
                          <label>State</label>
                          <Field
                            type="text"
                            name="state"
                            className="form-control"
                            placeholder="State"
                          />
                          <ErrorMessage
                            name="state"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="form-group full-width">
                          <label>Postcode</label>
                          <Field
                            type="number"
                            name="postcode"
                            className="form-control"
                            placeholder="Postcode"
                          />
                          <ErrorMessage
                            name="postcode"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </div>
                      <div className="form-group full-width">
                        <label>ABN</label>
                        <Field
                          type="text"
                          name="abn"
                          className="form-control"
                          placeholder="ABN"
                          style={{ backgroundColor: "white" }}
                        />
                        <ErrorMessage
                          name="abn"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </div>
                    <div className="gap-3 submit">
                      <button
                        type="button"
                        className="submit-btn"
                        onClick={() => {
                          localStorage.removeItem("user_profile_role");
                          localStorage.removeItem("term_and_conditions");
                          props.setIsMemberShipModalOpen(false);
                          props.setNewModalOpen(true);
                          localStorage.setItem("isnewuser", true);
                        }}
                      >
                        Skip
                      </button>
                      <button type="submit" className="submit-btn">
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MembershipFormPopup;
